<template>
  <div class="md-layout-item md-size-50 md-xsmall-size-90">
    <md-field :class="{'md-has-value': ((currentValue !== '' && (currentValue != null && currentValue.length !== 0)) || onFocus)}">
      <label class="black">{{ label }}</label>
        <v-select
          v-bind:name="name"
          v-model="currentValue"
          v-bind:options="optionsValues"
          v-validate="validations"
          v-on:input="$emit('input', currentValue)"
          v-on:change="$emit('input', currentValue)"
          v-on:search:focus="onFocus = true"
          v-on:search:blur="onFocus = false"
          v-bind:multiple="multi"
          v-bind="attributes"
        >
          <span slot="no-options">No hay opción diponible</span>
        </v-select>
    </md-field>
  </div>
</template>
<script>
import service from "@/services/agencies";

export default {
  name: "SelectList",
  inject: ['$validator'],
  props: ["multi", "options", "name", "label", "value", "validations", "attributes"],
  data: () => ({
    optionsValues: [],
    currentValue: '',
    onFocus: false,
  }),
  methods: {
    updateOptions: function(options) {
      this.optionsValues = options;
    },
    getSelected: function() {
      return this.currentValue;
    }
  },
  mounted() {
    this.options.forEach(element => {
      try {
         if (element.includes('db_list_')) {
          const URI = element.substring(8, element.length);
          service.getGenericURI(URI).then(({ data: { result, status } }) => {
            if (status == "ok") {
              this.optionsValues = [...this.optionsValues, ...result];
            }
            this.currentValue = this.value;
            if ((this.value == null || this.value == '') && this.options.length >= 1) {
              this.currentValue = this.optionsValues[1];
            }
          });
        } else {
          this.optionsValues.push(element);
          if ((this.value == null || this.value == '') && this.options.length >= 1 && this.attributes.allow_default) {
            this.currentValue = this.options[0];
            this.$emit("input", this.currentValue);
          }
        }
      } catch (error) {
      }
    });
    if (this.optionsValues.length === 0 && this.options.length > 1) {
      this.optionsValues = this.options;
    }
    if (this.currentValue == null || this.currentValue == '') {
      this.currentValue = this.value;
    }
  }
};
</script>